import { useState, useEffect, useRef } from "react";
import DocumentPreview from "./documentpreview";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const DocumentRow = ({ document }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Handle file click
  const handleFileClick = (file) => {
    setcurrentDocument(file);
    setIsModalOpen(true);
  };
  const formatDate = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const handleScroll = () => {
    console.log("In scroll, I am scroll event listener.");

    if (isMenuOpen !== null) {
      setIsMenuOpen(null);
    }
  };
  useEffect(() => {
    if (isMenuOpen !== null) {
      console.log("Dropdown opened, adding scroll event listener.");
      window.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      console.log("Dropdown closed, removing scroll event listener.");
      window.removeEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMenuOpen]);

  return (
    <div onScroll={handleScroll} className="">
      {/* Table Heading */}
      <div className="w-full overflow-x-auto  border">
        <div className="grid grid-cols-[auto_auto_2.5fr_1fr_1fr_1fr] items-center gap-4 py-3 font-medium text-[#8C8C8C] text-sm ">
          <span></span>
          <span>Document ID</span>
          <span>Document Name</span>
          <span>Date Added</span>
          <span>File</span>
          <span>Status</span>
        </div>
      </div>
      <div
        onScroll={handleScroll}
        className={`w-full bg-white py-4 overflow-x-auto`}
      >
        <div className="grid gap-y-4">
          {document.map((document, index) => (
            <div
              key={document.document_id}
              className="grid grid-cols-[auto_0.5fr_2.5fr_1fr_1fr_1fr] items-center gap-4 py-4 pl-2 text-sm bg-[#F9F9F9] shadow-sm rounded-md"
            >
              {/* Row Number */}
              <span className="text-[#8C8C8C]">
                {(index + 1).toString().padStart(2, "0")}
              </span>

              {/* Document ID */}
              <span>{document.unique_id}</span>

              {/* Document Name (No Truncation) */}
              <span className="lg:break-all max-w-[300px]">
                {document.document_name}
              </span>

              {/* Date Added */}
              <span>{formatDate(document.date_uploaded)}</span>

              {/* File */}
              <span
                onClick={() => handleFileClick(document)}
                className="bg-white p-2 cursor-pointer font-medium rounded-xl"
              >
                {document.file_name}
              </span>
              <span> {document.status == 1 ? "Active" : "InActive"}</span>
            </div>
          ))}
        </div>
      </div>
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.signed_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};
const DocumentsSection = ({ IsUpdate, investment_id }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [actualData, setactualData] = useState([]);
  const { showToast } = useToast();

  const documentIds = useSelector((state) => state.documents.documentIds);
  const GetInvestmentList = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/my-investment/portfolio/documents`;
    const headers = {
      "Content-Type": "application/json",
    };
    const bodyData = {
      document_ids: documentIds.length > 0 ? documentIds : [],
      name: searchTerm != "" > 0 ? searchTerm : "",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAll = async () => {
    try {
      const response = await GetInvestmentList();

      if (response.status == 200) {
        setactualData(response.data);
      } else {
        if (response.status === 401) {
          // Token expired or invalid
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setactualData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  useEffect(() => {
    if (documentIds.length == 0) {
    } else {
      getAll();
    }
  }, [searchTerm, documentIds]);
  return (
    <div className="rounded-md shadow bg-white p-6 mt-6">
      {/* Search & Add Button Section */}
      <div className="w-full p-4">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
          {/* Heading */}
          <h2 className="text-lg font-medium text-black">Documents</h2>

          {/* Search Bar and Add Button */}
          <div className="flex items-center gap-4 w-full md:w-auto">
            {/* Search Input with Icon */}
            <div className="relative flex-grow md:flex-grow-0 w-full md:w-64">
              <img
                src="/search-normal.svg" /* Replace with your search icon image */
                alt="Search"
                className="absolute left-3 top-1/2 transform -translate-y-1/2 h-3 w-3 text-gray-400"
              />
              <input
                placeholder="Search Document"
                type="text"
                className="w-full pl-10 pr-4 py-2 border rounded-xl text-sm text-gray-700 placeholder-gray-400 focus:ring-2 focus:ring-black focus:outline-none"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Document Rows */}
      <div className="px-4 sm:px-4 lg:px-4">
        {actualData && <DocumentRow document={actualData} />}
      </div>
    </div>
  );
};

export default DocumentsSection;
